import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Configuration } from "src/assets/Configuration";
import { OnboardingPageModel } from "../../models/onboarding/onboarding-page.model";

@Injectable({
  providedIn: 'root'
})
export class OnboardingService {
  constructor(private httpClient: HttpClient) {}

  getOnboardingPages(): Observable<OnboardingPageModel[]> {
    return this.httpClient.get<OnboardingPageModel[]>(
      Configuration.getApiBaseUrl() + '/onboarding/pages'
    );
  }

  completeOnboarding(): Observable<void> {
    return this.httpClient.post<void>(
      Configuration.getApiBaseUrl() + '/onboarding/complete',
      {}
    );
  }

  isOnboardingCompleted(): Observable<boolean> {
    return this.httpClient.get<boolean>(
      Configuration.getApiBaseUrl() + '/onboarding/completed'
    );
  }
}